// extracted by mini-css-extract-plugin
export default {"highlight":"HighlightWord__highlight-AX6f"};